import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';

import { jwt } from '@environments/environment';
import Resources from '../constants/resourses';
import { SessionService } from './session.service';

import { RestapiService } from './restapi.service';
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class JwtService {
  constructor(private restapi: RestapiService, private http: HttpClient, private sessionService: SessionService) { }

  private jwt: any = {};

  // async addKeyToCache(key) {

  //   const postData = async (key) => {

  //     const URL =  jwt.authorizeURL;

  //     try {
  //       const response = await axios.post(URL, { idToken: key });
  //       if (response) {
  //         return true;
  //       }
  //     } catch (error) {
  //       return false;
  //     };
  //   };

  //   return await postData(key)
  // };

  addKeyToCache(key, proof?: string): Observable<any> {
    const URL = jwt.authorizeURL;
    this.sessionService.setData(Resources.SessionStorageKeys.AuthorizeIdToken, key);
    // Send both proof (DPoP JWT) and hash (sha256 of jti) for binding validation
    const payload = proof ? { proof: proof, hash: key } : { idToken: key };
    return this.http.post(URL, payload).pipe(
      retry(1)
    );
  }

  // Below not optimised

  getJWT() {
    return this.jwt;
  }



  base64url(source) {
    var encodedSource = CryptoJS.enc.Base64.stringify(source);

    encodedSource = encodedSource.replace(/=+$/, '');

    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');

    return encodedSource;
  }

  // Get Token
  getToken(header, data) {

    var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    var encodedHeader = this.base64url(stringifiedHeader);

    var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
    var encodedData = this.base64url(stringifiedData);

    var token = encodedHeader + "." + encodedData;

    var signature = CryptoJS.HmacSHA256(token, 'const');
    var encodedsignature = this.base64url(signature);

    var signedToken = token + "." + encodedsignature;

    return signedToken;
  }

  addHashToCache(keyId): Observable<any> {

    let uuid_val = uuidv4();
    const header = {
      alg: "HS256",
      typ: "JWT"
    };
    const data = {
      token_use: 'id',
      jti: String(uuid_val),
      keyid: keyId,
      expires: moment().add(30, 'minutes').toISOString()
    };
    const token = this.getToken(header, data);

    uuid_val = uuid_val.concat('function()');
    var uuid_val1 = CryptoJS.SHA256(uuid_val);
    uuid_val = CryptoJS.enc.Hex.stringify(uuid_val1);

    const isAdded = this.addKeyToCache(uuid_val);

    if (isAdded) {
      // this.restapi.setAccToken(token)
      this.sessionService.setData(Resources.SessionStorageKeys.AccessToken, 'true');
      this.jwt = token;
      return of({ hash: token });
    } else
      return of({ hash: undefined });
  }

  // Generate JWT Token
  generateJWTToken(keyId) {
    let uuid = uuidv4();
    const header = {
      alg: "HS256",
      typ: "JWT"
    };
    const data = {
      token_use: 'id',
      jti: String(uuid),
      keyid: keyId
    };

    const token = this.getToken(header, data);
    uuid = uuid.concat('function()');

    const cryptoEnc = CryptoJS.SHA256(uuid);
    uuid = CryptoJS.enc.Hex.stringify(cryptoEnc);

    return {
      uuidVal: uuid,
      accessToken: token
    };
  }
}
